exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".last-order-modal[data-v-55b2683f]{font-size:22px}.close-btn[data-v-55b2683f]{right:10px;top:10px}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/LastOrderModal.vue"],"names":[],"mappings":"AACA,mCACE,cAAgB,CACjB,AACD,4BACE,WAAY,AACZ,QAAU,CACX","file":"LastOrderModal.vue","sourcesContent":["\n.last-order-modal[data-v-55b2683f] {\n  font-size: 22px;\n}\n.close-btn[data-v-55b2683f] {\n  right: 10px;\n  top: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55b2683f","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/LastOrderModal.vue
// module id = 524
// module chunks = 5